import { SSIO } from '../types';

export const iosEqual = (a: SSIO, b: SSIO): boolean =>
  a.node === b.node && a.type === b.type && a.index === b.index;
